import PageHero from '../components/PageHero';
import ContactForm from '../components/ContactForm';
import { Mail, Phone } from 'lucide-react';
import { companyInfo } from '../data';
import SEO from '../components/SEO';

export default function Contact() {
  return (
    <main className="bg-white">
      <SEO 
        title="Kontakt FINANJU | Få en Uforpligtende Dialog om Din Virksomhed"
        description="Kontakt FINANJU for professionel rådgivning om økonomi og jura. Ring på 40 15 49 69 eller skriv til kontakt@finanju.dk. Vi er klar til at hjælpe."
        path="/kontakt"
      />
      <PageHero
        title="Kontakt FINANJU"
        subtitle="Vi er altid klar til en uforpligtende dialog om, hvordan vi kan hjælpe din virksomhed med at skabe struktur og overblik."
        breadcrumbs={[{ name: 'Kontakt', href: '/kontakt' }]}
      />

      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16">
            <div className="mb-16 lg:mb-0">
              <h2 className="text-3xl font-bold text-slate-900 mb-8">Lad os tage en dialog</h2>
              <p className="text-lg text-slate-500 leading-relaxed mb-12">
                Har du spørgsmål til vores ydelser, eller ønsker du at høre mere om, hvordan vi kan assistere din virksomhed? Udfyld formularen, eller kontakt os direkte via telefon eller e-mail.
              </p>

              <div className="space-y-8">
                <div className="flex items-start gap-4">
                  <div className="mt-1 p-3 bg-[#876a57]/10 rounded-sm text-[#876a57]">
                    <Phone className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 text-lg mb-1">Telefon</h3>
                    <a href={`tel:${companyInfo.phone}`} className="text-[#876a57] font-medium hover:text-[#876a57]/90 transition-colors text-lg">
                      {companyInfo.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="mt-1 p-3 bg-[#876a57]/10 rounded-sm text-[#876a57]">
                    <Mail className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 text-lg mb-1">E-mail</h3>
                    <p className="text-slate-500 mb-2">Send os en mail, og vi vender tilbage hurtigst muligt.</p>
                    <a href={`mailto:${companyInfo.email}`} className="text-[#876a57] font-medium hover:text-[#876a57]/90 transition-colors">
                      {companyInfo.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="bg-slate-50 p-8 rounded-sm mb-8 border border-slate-200">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Send en besked</h3>
                <p className="text-slate-500 mb-8">Udfyld felterne nedenfor, så kontakter vi dig til en uforpligtende dialog.</p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
